import React from 'react';

const FinalistsBoard = ({ title, finalists }) => (
  <section className="py-10 sm:py-16 px-4" style={{ backgroundColor: 'var(--tp-black)' }} data-testid="finalists-section">
    <div className="max-w-4xl mx-auto">
      <h3 className="text-3xl sm:text-4xl font-bold text-center mb-2 text-white"
        style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }} data-testid="finalists-title">
        {title}
      </h3>
      <div className="w-20 h-1 mx-auto mb-8" style={{ backgroundColor: 'var(--tp-red)' }} />

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3 max-w-3xl mx-auto">
        {[
          ...finalists,
          ...Array(Math.max(0, 16 - finalists.length)).fill({ name: 'TBD', link: null })
        ].map((finalist, index) => (
          <div key={`${finalist.name}-${index}`} className="relative rounded-lg border-2 border-gray-700 hover:border-red-600 transition-colors duration-300 p-3 text-center min-h-[60px] flex items-center justify-center"
            style={{ backgroundColor: 'var(--tp-dark)' }}>
            {finalist.isNew && (
              <span
                data-testid={`finalist-new-badge-${index}`}
                className="absolute -top-2 -right-2 px-2 py-0.5 rounded-full text-[10px] font-bold text-white animate-pulse shadow-lg z-10"
                style={{ backgroundColor: 'var(--tp-red)', fontFamily: 'Oswald, sans-serif', letterSpacing: '1px' }}
              >
                NEW
              </span>
            )}
            {finalist.link ? (
              <a
                href={finalist.link}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`finalist-btn-${index}`}
                aria-label={`Apri profilo Instagram di ${finalist.name}`}
                className="text-white font-bold text-2xl sm:text-3xl hover:text-red-400 transition-colors duration-300"
                style={{ fontFamily: 'Oswald, sans-serif' }}
              >
                {finalist.name}
              </a>
            ) : (
              <span className={`${finalist.name === 'TBD' ? 'text-gray-500 text-xs' : 'text-white font-bold text-2xl sm:text-3xl'}`} style={{ fontFamily: 'Oswald, sans-serif' }}>
                {finalist.name}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FinalistsBoard;
